import useGetAccessToken from 'components/Dashboard/apiCalls/useGetAccessToken';
import BlockchainKeywordContainer from 'components/Dashboard/components/BlockchainKeywordContainer';
import { store } from 'components/Store';
import { useContext, useRef } from 'react';
import { createRoot } from 'react-dom/client';

const useProccessKeywords = () => {
  const globalState = useContext(store);
  const { state } = globalState ?? {};
  const { activePlan } = state;
  const { enableAnalytics } = activePlan;

  const { getAccessToken } = useGetAccessToken();

  const tokenRef = useRef(null);
  let cancelled = false;

  const processKeywords = async ({ container, reportWidget, isAuthenticated, setShowAnalyticsPopup }) => {
    if (!container || reportWidget) return;
    if (cancelled) return;
    const getTokenOnce = async () => {
      if (tokenRef.current !== null) return tokenRef.current;
      tokenRef.current = isAuthenticated ? await getAccessToken() : null;
      return tokenRef.current;
    };
    const token = await getTokenOnce();
    const elements = container.querySelectorAll('em.policymogul-keyword-match');
    elements.forEach((element) => {
      if (!element.isConnected) return;
      if (element.closest('.blockchain-keyword-container')) return;
      if (element.closest('.main-title')) return;
      if (element.closest('a')) return;
      // Merge adjacent or whitespace-separated keyword matches into a single <em>
      // so we wrap them once with a single BlockchainKeywordContainer
      let node = element.nextSibling;
      let merged = false;
      let textToAppend = '';
      const nodesToRemove = [];
      while (node) {
        if (node.nodeType === 3) {
          // Text node
          if (node.textContent.trim() === '') {
            textToAppend += node.textContent;
            nodesToRemove.push(node);
            node = node.nextSibling;
            continue;
          }
          break; // Non-whitespace text between elements stops merging
        }
        if (node.nodeType === 1 && node.matches && node.matches('em.policymogul-keyword-match')) {
          textToAppend += node.textContent;
          nodesToRemove.push(node);
          merged = true;
          node = node.nextSibling;
          continue;
        }
        break; // Different element encountered; stop merging
      }
      if (merged) {
        element.textContent += textToAppend;
        nodesToRemove.forEach((n) => n.remove());
      }
      const wrapper = document.createElement('span');
      wrapper.className = 'blockchain-keyword-container';
      wrapper.style.display = 'inline';
      // Keep original text to avoid blank while React mounts
      wrapper.textContent = element.innerText;
      element.replaceWith(wrapper);
      const root = createRoot(wrapper);
      root.render(
        <BlockchainKeywordContainer
          keyword={element.innerText}
          token={token}
          enableAnalytics={enableAnalytics}
          setShowAnalyticsPopup={setShowAnalyticsPopup}
          isAuthenticated={isAuthenticated}
        />
      );
    });
  };
  return { processKeywords };
};

export default useProccessKeywords;
